export default (function (astGenerator, language) {
  var langs = astGenerator.listLanguages();
  return langs.indexOf(language) !== -1;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-syntax-highlighter/dist/esm/checkForListedLanguage.js
// module id = 978
// module chunks = 0